import React, { useState } from "react";
import clsx from "clsx";

import { Button, Theme, useMediaQuery } from "@mui/material";
import { makeStyles } from "@mui/styles";
import {
  IdsExpandMore as ArrowDropDownIcon,
  IdsExpandLess as ArrowDropUpIcon,
} from "components/shared/svgIcons";
import { startCase } from "lodash";

import { Menu, MenuItem } from "components/shared";
import useApp from "hooks/useApp";
import useCatalogDetail from "hooks/useCatalogDetail";
import { DesignType, IDesign, PlatformType, Workflow } from "types/design";

interface PlatformButtonProps {
  isEvaluation: boolean;
  platform: PlatformType | undefined;
  requisitionId: string | undefined;
  setPlatform: React.Dispatch<React.SetStateAction<PlatformType | undefined>>;
}

const useStyles = makeStyles((theme: Theme) => ({
  menu: {
    width: 165,
  },
  menuLabel: {
    display: "flex",
    justifyContent: "space-between",
  },
  platformBtn: {
    display: "flex",
    justifyContent: "space-between",
    "& .MuiButton-iconSizeMedium, & .MuiButton-iconSizeSmall": {
      "& > *:first-child": { fontSize: theme.typography.pxToRem(24) },
    },
    "& .MuiButton-endIcon.MuiButton-iconSizeSmall, & .MuiButton-endIcon.MuiButton-iconSizeMedium":
      {
        marginLeft: theme.spacing(0.25),
        marginRight: theme.spacing(-1),
      },
  },
  flexOrder: {
    [theme.breakpoints.only("sm")]: { order: 2 },
    [theme.breakpoints.down("sm")]: { order: 1 },
  },
}));

export const SelectPlatformButton: React.FC<PlatformButtonProps> = ({
  isEvaluation,
  platform,
  requisitionId,
  setPlatform,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const mdUp = useMediaQuery((theme: Theme) => theme.breakpoints.up("md"));
  const { getWorkflow } = useApp();
  let { catalog } = useCatalogDetail();
  catalog = catalog as IDesign;

  const isCatalogPanel = catalog.designType === DesignType.CATALOG_PANEL;
  const classes = useStyles({ platformDropdownActive: Boolean(anchorEl) });

  const openMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  return (
    <>
      <Button
        fullWidth={mdUp}
        size={mdUp ? "medium" : "small"}
        variant="outlined"
        endIcon={
          Boolean(anchorEl) ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />
        }
        onClick={openMenu}
        classes={{
          // label: classes.menuLabel,
          root: clsx(classes.platformBtn, classes.flexOrder),
        }}
        disabled={(!isCatalogPanel || !isEvaluation) && !!requisitionId}
      >
        {platform ? startCase(platform) : "Select platform"}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        onClick={() => setAnchorEl(null)}
        classes={{ paper: classes.menu }}
      >
        {(Object.keys(PlatformType) as Array<keyof typeof PlatformType>).map(
          (platformType: keyof typeof PlatformType) => (
            <MenuItem
              key={PlatformType[platformType]}
              size="sm"
              disabled={
                PlatformType[platformType] === PlatformType.IONTORRENT &&
                getWorkflow(catalog?.workflow)?.name !== Workflow.FUSION
              }
              onClick={() => setPlatform(PlatformType[platformType])}
            >
              {startCase(PlatformType[platformType])}
            </MenuItem>
          )
        )}
      </Menu>
    </>
  );
};
